// extracted by mini-css-extract-plugin
module.exports = {"float":"Float_float__TFsIw"};